import React from "react";
import Swal from "sweetalert2";

export default function DeliveredButton({ orderId, onDelivered }) {
  const handleDeliveredClick = () => {
    Swal.fire({
      title: `<h4>Are you sure you want to mark this order as delivered?</h4>`,
      text: "Once confirmed, the status will be updated!",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, mark as delivered!",
      customClass: {
        title: "swal-custom-title",
        icon: "swal-custom-icon",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        onDelivered(orderId);
      }
    });
  };

  return (
    <button
      className="confirm-button btn btn-success mt-5"
      onClick={(e) => {
        e.preventDefault(); // Prevent page reload
        handleDeliveredClick();
      }}
    >
      DELIVERED
    </button>
  );
}
